/** @deprecated Import from localeRouteRegistry.js */
export { weddingGuidePaths } from "./localeRouteRegistry";
